import React from 'react';
import styled from 'styled-components';
import RupeeIconSvg from '../assets/hotels/home/rupee.svg';

const RupeeIcon = styled(RupeeIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || 'black'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default RupeeIcon;
